import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  input,
  output,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { hugeTime02 } from '@ng-icons/huge-icons';
import { CounterComponent } from '../counter/counter.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { TimerComponent } from '../timer/timer.component';
import { PadStartPipe } from '@coworkrz/shared/misc';

@Component({
  selector: 'ui-calendar-timer',
  imports: [
    CommonModule,
    NgIconComponent,
    CounterComponent,
    OverlayModule,
    TimerComponent,
    PadStartPipe,
  ],
  viewProviders: [
    provideIcons({
      hugeTime02,
    }),
  ],
  templateUrl: './calendar-timer.component.html',
})
export class CalendarTimerComponent {
  readonly trigger =
    viewChild.required<ElementRef<HTMLButtonElement>>('button');
  readonly isOpenSpace = input(false);
  readonly maxHours = input(11);
  readonly counterNumber = input<number>();
  readonly bookingDay = input<Date>(new Date());
  readonly availableSlots = input<
    {
      startTime: string;
      endTime: string;
    }[]
  >([]);
  hasBottomSpace = false;
  opened = false;

  @Input() numberHours: number;
  readonly numberHoursEmitter = output<number>();

  @Input() time: { hour: number; minute: number };
  readonly currentTime = output<{
    hour: number;
    minute: number;
  }>();

  getTime(event: { hour: number; minute: number }) {
    this.time = event;
    this.currentTime.emit(event);
  }

  getCounterNumber(event: number) {
    this.numberHours = event;
    console.log(event);
    this.numberHoursEmitter.emit(event);
  }

  open(): void {
    const rect = this.trigger().nativeElement.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    this.hasBottomSpace = bottomSpace > 300;
    this.opened = true;
  }

  close(): void {
    this.opened = false;
  }
}
